module.exports = __webpack_public_path__ + "img/edit-apperance-img.bdac6b62.png";